/* ============================================================
   Gold Perfumes — motor de la tienda
   Cabecera, megamenú con vista previa, buscador agrupado, carro,
   favoritos, comparador y venta cruzada.
   Un solo archivo: no hay copias que se desincronicen entre páginas.
   ============================================================ */
(function () {
'use strict';

var D = window.GP || { productos: [], sim: {}, cross: {} };
var P = D.productos;
var IX = {};
P.forEach(function (p) { IX[p.i] = p; });

/* ---------- constantes de negocio ---------- */
// Quiénes dan las 3 cuotas sin interés. El nombre se usa en el texto y el slug busca
// el logo en Archivos (alt "pago:<slug>").
var MEDIOS_CUOTAS = [{ s: 'venti', n: 'VentiPay' }];
var UMBRAL_ENVIO = 100000;          // Región Metropolitana
var UMBRAL_REGIONES = 150000;       // resto de Chile
var CUOTAS = 3;
var MIN_CUOTA = 0;                  // sin mínimo: el cálculo va en todas las fichas
var TOPE_RETIRO = 17;
var WA = '56965529189';
var DIR = 'Av. Providencia 1336, Local 18';
var HORARIO = { 1: [10.5, 19.5], 2: [10.5, 19.5], 3: [10.5, 19.5], 4: [10.5, 19.5], 5: [10.5, 19.5], 6: [11, 15], 0: null };
var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

/* ---------- utilidades ---------- */
function $(s, c) { return (c || document).querySelector(s); }
function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
function clp(n) { return '$' + Math.round(n).toLocaleString('es-CL'); }
GP.clp = clp;
function foto(p) { return (p && p.img) || ''; }
function logo(p) { return (p && p.logo) || ''; }
function amb(slug) { return (D.archivos || {})[slug] || ''; }
function url(p) { return '/products/' + p.h; }
function sinAcento(s) { return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); }
function hora(h) { var e = Math.floor(h), m = Math.round((h - e) * 60); return e + ':' + (m < 10 ? '0' : '') + m; }

function cuota(precio) {
  if (precio < MIN_CUOTA) return '';
  return CUOTAS + ' cuotas sin interés de ' + clp(Math.ceil(precio / CUOTAS));
}
function tipoCorto(p) {
  return ({ 'Eau de Parfum': 'EDP', 'Eau de Toilette': 'EDT', 'Extrait de Parfum': 'Extrait', 'Parfum': 'Parfum' })[p.t] || (p.t || '');
}
function meta(p) {
  var a = [];
  if (p.ml) a.push(p.ml + ' ml');
  if (tipoCorto(p)) a.push(tipoCorto(p));
  if (p.g) a.push(p.g);
  return a.join(' · ');
}
function notasDe(p) { return [].concat(p.no.s || [], p.no.c || [], p.no.f || []); }
function porMl(p) { return p.ml ? p.p / p.ml : null; }


/* --- rutas de Shopify -------------------------------------------------
   La demo enlazaba a tienda.html?g=Hombre&fam=Floral. Aquí eso se traduce
   a colecciones reales (y a su filtro por etiqueta, que Shopify entiende
   nativamente) para que las páginas de catálogo las sirva el servidor. */
var GENCOL = {'Hombre':'hombre','Mujer':'mujer','Unisex':'unisex'};
var CASACOL = {'arabe':'perfumes-arabes','disenador':'disenador','nicho':'nicho'};
var AROMACOL = ['floral','oriental','amaderado','frutal','aromatico','gourmand','citrico','especiado'];
function tag(x){
  return String(x || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}
function T(q){
  q = q || {};
  if (q.q) return '/search?q=' + encodeURIComponent(q.q);
  if (q.nota) return '/collections/catalogo?nota=' + encodeURIComponent(q.nota);
  if (q.m) return '/collections/catalogo?m=' + encodeURIComponent(q.m);
  var base = null;
  if (q.g && GENCOL[q.g]) base = GENCOL[q.g];
  else if (q.k && CASACOL[q.k]) base = CASACOL[q.k];
  else if (q.tester) return '/collections/testers';
  else if (q.ref) return '/collections/dupes';
  else if (q.fo === 'mist') return '/collections/body-mist';
  if (q.fam){
    var t = tag(q.fam);
    if (base) return '/collections/' + base + '/' + t;
    if (AROMACOL.indexOf(t) >= 0) return '/collections/aroma-' + t;
    return '/collections/catalogo/' + t;
  }
  if (base){
    var extra = [];
    if (q.max) extra.push('max=' + q.max);
    if (q.min) extra.push('min=' + q.min);
    if (q.orden) extra.push('orden=' + q.orden);
    return '/collections/' + base + (extra.length ? '?' + extra.join('&') : '');
  }
  var p = [];
  ['min','max','orden','g','k'].forEach(function(k){ if (q[k]) p.push(k + '=' + encodeURIComponent(q[k])); });
  return '/collections/catalogo' + (p.length ? '?' + p.join('&') : '');
}
GP.T = T;

/* --- cifras vivas para los módulos editables ---------------------------
   Las secciones del tema escriben un token, por ejemplo {arabes} o {desde-arabe},
   y aquí se reemplaza por la cifra real del catálogo. Así la clienta edita el
   texto desde el personalizador sin que los números queden viejos. */
GP.dato = function (txt) {
  if (txt === null || txt === undefined) return '';
  // con los agotados fuera del catálogo, las cifras tampoco los cuentan: si no,
  //   la portada decía 236 en vitrina y el catálogo pintaba 231
  var P = (GP.productos || []).filter(function(p){
    return !(GP.agotado && GP.agotado.mostrar === false && GP.agotadoP && GP.agotadoP(p));
  });
  function n(f){ return P.filter(f).length; }
  function desde(f){ var l = P.filter(f).map(function(p){ return p.p; }); return l.length ? Math.min.apply(null, l) : 0; }
  function pesos(v){ return '$' + Math.round(v).toLocaleString('es-CL'); }
  var T = {
    'total':        function(){ return P.length; },
    'arabes':       function(){ return n(function(p){ return p.k === 'arabe'; }); },
    'disenador':    function(){ return n(function(p){ return p.k === 'disenador'; }); },
    'nicho':        function(){ return n(function(p){ return p.k === 'nicho'; }); },
    'testers':      function(){ return n(function(p){ return p.te; }); },
    'dupes':        function(){ return n(function(p){ return p.ins; }); },
    'mist':         function(){ return n(function(p){ return p.fo === 'mist'; }); },
    'hombre':       function(){ return n(function(p){ return p.g === 'Hombre'; }); },
    'mujer':        function(){ return n(function(p){ return p.g === 'Mujer'; }); },
    'unisex':       function(){ return n(function(p){ return p.g === 'Unisex'; }); },
    'alta-gama':    function(){ return n(function(p){ return p.k === 'nicho' || p.p >= 90000; }); },
    'marcas':       function(){ var s = {}; P.forEach(function(p){ if (p.b) s[p.b] = 1; }); return Object.keys(s).length; },
    'desde':        function(){ return pesos(desde(function(p){ return p.fo === 'perfume'; })); },
    'desde-arabe':  function(){ return pesos(desde(function(p){ return p.k === 'arabe' && p.fo === 'perfume'; })); },
    'desde-disenador': function(){ return pesos(desde(function(p){ return p.k === 'disenador' && p.fo === 'perfume'; })); },
    'desde-nicho':  function(){ return pesos(desde(function(p){ return p.k === 'nicho' && p.fo === 'perfume'; })); },
    'mas-alto':     function(){ return pesos(Math.max.apply(null, P.map(function(p){ return p.p; }))); },
    'sobre-100':    function(){ return n(function(p){ return p.p >= 100000; }); },
    'envio-gratis': function(){ return pesos((GP.ajustes && GP.ajustes.umbral) || 49990); },
    'casas-arabes': function(){ return lista(function(p){ return p.k === 'arabe'; }, 4, true); },
    'casas-disenador': function(){ return lista(function(p){ return p.k === 'disenador'; }, 6, false); },
    'casas-nicho': function(){ return lista(function(p){ return p.k === 'nicho'; }, 4, false); },
    'edp-arabes':  function(){ return n(function(p){ return p.k === 'arabe' && p.t === 'Eau de Parfum'; }); },
    'extrait-arabes': function(){ return n(function(p){ return p.k === 'arabe' && /Extrait|^Parfum$/.test(p.t || ''); }); },
    'rango-alta-gama': function(){
      var l = P.filter(function(p){ return (p.k === 'nicho' || p.p >= 90000) && p.fo === 'perfume'; }).map(function(p){ return p.p; });
      return l.length ? pesos(Math.min.apply(null, l)) + ' a ' + pesos(Math.max.apply(null, l)) : '';
    },
    'mas-caro': function(){
      var l = P.slice().sort(function(a, b){ return b.p - a.p; });
      return l.length ? l[0].n + ' a ' + pesos(l[0].p) : '';
    },
    'ahorro-tester': function(){
      // cuánto menos cuesta, por mililitro, el tester frente al mismo perfume en caja
      var t = P.filter(function(p){ return p.te && p.ml; });
      if (!t.length) return '';
      var mejor = 0;
      t.forEach(function(a){
        P.forEach(function(b){
          if (b.te || !b.ml || b.b !== a.b) return;
          if (GP.sinAcento(b.n).indexOf(GP.sinAcento(a.n).replace(/\s*\.?\s*tester\s*$/, '')) < 0) return;
          var d = Math.round(100 * (1 - (a.p / a.ml) / (b.p / b.ml)));
          if (d > mejor && d < 80) mejor = d;
        });
      });
      return mejor ? mejor + '%' : '';
    }
  };

  /* las casas más presentes de un grupo, para nombrarlas en el texto */
  function lista(f, cuantas, conCuenta){
    var c = {};
    P.forEach(function(p){ if (f(p) && p.b) c[p.b] = (c[p.b] || 0) + 1; });
    return Object.keys(c).sort(function(a, b){ return c[b] - c[a]; }).slice(0, cuantas)
      .map(function(m){ return conCuenta ? m + ' (' + c[m] + ')' : m; }).join(', ');
  }
  return String(txt).replace(/\{([a-z0-9-]+)\}/g, function (m, k) {
    return T[k] ? String(T[k]()) : m;
  });
};

/* Rellena en el documento todo lo que traiga un token. Las secciones escriben
   data-gp-dato="{arabes}" y el motor lo resuelve al pintar la página. */
GP.pintarDatos = function (raiz) {
  var nodos = (raiz || document).querySelectorAll('[data-gp-dato]');
  for (var i = 0; i < nodos.length; i++) {
    nodos[i].textContent = GP.dato(nodos[i].getAttribute('data-gp-dato'));
  }
};

GP.fmt = clp; GP.ix = IX;

/* ---------- ¿está abierto el local ahora? ---------- */
function estadoLocal() {
  var ahora;
  try { ahora = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Santiago' })); }
  catch (e) { ahora = new Date(); }
  var d = ahora.getDay(), h = ahora.getHours() + ahora.getMinutes() / 60;
  var hoy = HORARIO[d];
  if (hoy && h >= hoy[0] && h < hoy[1]) {
    var retira = h < TOPE_RETIRO;
    return { abierto: true, texto: 'Abierto ahora · cierra a las ' + hora(hoy[1]), corto: 'Abierto',
             detalle: 'cierra a las ' + hora(hoy[1]),
             retiro: retira ? 'Pide antes de las ' + TOPE_RETIRO + ':00 y retiras hoy mismo' : 'Pide ahora y retiras mañana' };
  }
  for (var i = 0; i <= 7; i++) {
    var dd = (d + i) % 7, hh = HORARIO[dd];
    if (!hh) continue;
    if (i === 0 && h >= hh[0]) continue;
    var cuando = i === 0 ? 'hoy' : (i === 1 ? 'mañana' : 'el ' + DIAS[dd]);
    return { abierto: false, texto: 'Cerrado · abre ' + cuando + ' a las ' + hora(hh[0]), corto: 'Cerrado',
             detalle: 'abre ' + cuando + ' a las ' + hora(hh[0]),
             retiro: 'Puedes comprar ahora y retirar cuando abramos' };
  }
  return { abierto: false, texto: 'Cerrado', corto: 'Cerrado', detalle: '', retiro: '' };
}
GP.estadoLocal = estadoLocal;

/* ============================================================
   ALMACENAMIENTO
   ============================================================ */
function leer(k, def) { try { return JSON.parse(localStorage.getItem(k)) || def; } catch (e) { return def; } }
function escribir(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

var CARRO = [];                 /* se llena desde /cart.js */
var PORVAR = {};                 /* variante -> producto */
P.forEach(function (p) { if (p.vid) PORVAR[p.vid] = p; });

function pedir(ruta, cuerpo) {
  return fetch(ruta, {
    method: cuerpo ? 'POST' : 'GET',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: cuerpo ? JSON.stringify(cuerpo) : undefined,
  }).then(function (r) { return r.json(); });
}
function desdeShopify(c) {
  CARRO = (c.items || []).map(function (l) {
    var p = PORVAR[l.variant_id] || IX[l.product_id];
    return { i: p ? p.i : l.product_id, q: l.quantity, key: l.key,
             vid: l.variant_id, precio: Math.round(l.price / 100), linea: Math.round(l.line_price / 100) };
  }).filter(function (l) { return IX[l.i]; });
  pintarCarro();
}
function sincronizar() { return pedir(GP.rutas.carro + '.js').then(desdeShopify).catch(function () {}); }
var FAV = leer('gp_fav', []).filter(function (i) { return IX[i]; });
var CMP = leer('gp_cmp', []).filter(function (i) { return IX[i]; });
var VIS = leer('gp_vis', []).filter(function (i) { return IX[i]; });

function totalCarro() { return CARRO.reduce(function (s, l) { return s + (l.linea != null ? l.linea : IX[l.i].p * l.q); }, 0); }
function unidades() { return CARRO.reduce(function (s, l) { return s + l.q; }, 0); }

function agregar(id, q, silencio) {
  var p = IX[id];
  if (!p || !p.vid) return;
  q = q || 1;
  pedir(GP.rutas.agregar + '.js', { items: [{ id: p.vid, quantity: q }] })
    .then(function (r) {
      if (r && r.status && r.status !== 200) { toast(r.description || 'No quedan unidades'); return; }
      return sincronizar().then(function () { if (!silencio) abrirDrawer('carro'); });
    })
    .catch(function () { toast('No pudimos agregarlo, inténtalo de nuevo'); });
}
function cambiar(id, q) {
  var l = CARRO.filter(function (x) { return x.i === id; })[0];
  if (!l) return;
  pedir(GP.rutas.cambiar + '.js', { id: l.key, quantity: Math.max(0, l.q + q) }).then(desdeShopify);
}
function quitar(id) {
  var l = CARRO.filter(function (x) { return x.i === id; })[0];
  if (!l) return;
  pedir(GP.rutas.cambiar + '.js', { id: l.key, quantity: 0 }).then(desdeShopify);
}

function favToggle(id) {
  var k = FAV.indexOf(id);
  if (k >= 0) { FAV.splice(k, 1); toast('Quitado de favoritos'); }
  else { FAV.push(id); toast(IX[id].n + ' — guardado en favoritos'); }
  escribir('gp_fav', FAV); pintarFav();
  return k < 0;
}
function cmpToggle(id) {
  var k = CMP.indexOf(id);
  if (k >= 0) CMP.splice(k, 1);
  else {
    if (CMP.length >= 3) { toast('Puedes comparar hasta 3 a la vez'); return false; }
    CMP.push(id); toast('Sumado al comparador');
  }
  escribir('gp_cmp', CMP); pintarCmp();
  return k < 0;
}
function verReciente(id) {
  VIS = [id].concat(VIS.filter(function (x) { return x !== id; })).slice(0, 12);
  escribir('gp_vis', VIS);
}
GP.agregar = agregar; GP.favToggle = favToggle; GP.cmpToggle = cmpToggle; GP.verReciente = verReciente;
GP.fav = function () { return FAV.slice(); };
GP.cmp = function () { return CMP.map(function (i) { return IX[i]; }).filter(Boolean); };
GP.vistos = function () { return VIS.map(function (i) { return IX[i]; }).filter(Boolean); };

/* ============================================================
   ENVÍO GRATIS — la sugerencia SIEMPRE cruza el umbral
   ============================================================ */
/* ============================================================
   RUT PARA LA BOLETA
   La tienda está en plan Shopify (no Plus), así que no se puede agregar un campo
   nativo dentro del checkout. El RUT se pide en el CARRO y viaja como atributo del
   carro hasta la orden (note_attributes), que es de donde Syncron lo lee para emitir
   la boleta con el RUT del comprador y no con el genérico.
   ============================================================ */
function rutLimpio(v) {
  return String(v || '').replace(/[^0-9kK]/g, '').toUpperCase();
}
function rutValido(v) {
  var x = rutLimpio(v);
  if (x.length < 8 || x.length > 9) return false;
  var cuerpo = x.slice(0, -1), dv = x.slice(-1);
  if (!/^[0-9]+$/.test(cuerpo)) return false;
  var suma = 0, mul = 2;
  for (var i = cuerpo.length - 1; i >= 0; i--) {
    suma += parseInt(cuerpo.charAt(i), 10) * mul;
    mul = mul === 7 ? 2 : mul + 1;
  }
  var r = 11 - (suma % 11);
  return (r === 11 ? '0' : r === 10 ? 'K' : String(r)) === dv;
}
function rutFormato(v) {
  var x = rutLimpio(v);
  if (x.length < 2) return x;
  var cuerpo = x.slice(0, -1), dv = x.slice(-1);
  return cuerpo.replace(/\B(?=([0-9]{3})+(?![0-9]))/g, '.') + '-' + dv;
}
/* Bsale compara el code EXACTO: va sin puntos, con guion y K mayúscula. */
function rutBsale(v) {
  var x = rutLimpio(v);
  return x.slice(0, -1) + '-' + x.slice(-1);
}
GP.rutValido = rutValido; GP.rutFormato = rutFormato; GP.rutBsale = rutBsale;

function sugerirEnvio(base, excluir, maxItems) {
  var falta = UMBRAL_ENVIO - base;
  if (falta <= 0) return [];
  maxItems = maxItems || 3;
  excluir = excluir || [];
  // Tiene que tener STOCK: sugerir algo agotado deja el botón "agregar los 2" sin efecto
  // y es justo donde el cliente ya decidió gastar más.
  var pool = P.filter(function (p) {
    return p.img && excluir.indexOf(p.i) < 0 && !agotado(p);
  });
  var solos = pool.filter(function (p) { return p.p >= falta; }).sort(function (a, b) { return a.p - b.p; });
  if (solos.length) return [solos[0]];
  var orden = pool.slice().sort(function (a, b) { return b.p - a.p; });
  var acc = [], suma = 0;
  for (var i = 0; i < orden.length && acc.length < maxItems; i++) {
    acc.push(orden[i]); suma += orden[i].p;
    if (suma >= falta) return acc;
  }
  return [];
}

/* ============================================================
   EQUIVALENCIA DECLARADA — mismo formato y precio por ml
   ============================================================ */
function equiv(p) {
  var o = p.eq && IX[p.eq] ? IX[p.eq] : null;
  if (!o || !p.img || !o.img || o.fo !== p.fo || !p.ml || !o.ml) return null;
  var a = p.p / p.ml, b = o.p / o.ml;
  if (b <= a * 1.15) return null;
  return { o: o, mlA: a, mlB: b, pct: Math.round(100 * (1 - a / b)),
           ahorro: p.ml === o.ml ? (o.p - p.p) : Math.round((b - a) * p.ml) };
}
GP.equiv = equiv;

/* ============================================================
   TARJETA DE PRODUCTO
   ============================================================ */
/* ---------- sin stock ----------
   El cliente quiere que un perfume agotado siga apareciendo: en vez del botón de
   comprar ofrece avisar cuando llegue o pedirlo por encargo. Todo lo configurable
   vive en GP.agotado, que el layout llena desde los ajustes del tema. */
/* Un producto agotado, cuando el ajuste dice que no se muestre, tampoco debe contarse.
   Si no, los números del megamenú y de los filtros prometen más de lo que hay. */
GP.visible = function (p) {
  var o = opAgotado();
  return o.mostrar || !agotado(p);
};
/* Cómo llegar: se abre la app de mapas directo, no una página intermedia. */
var MAPS = 'https://www.google.com/maps/search/?api=1&query=' +
  encodeURIComponent('Gold Perfumes, Av. Providencia 1336, Local 18, Providencia, Santiago');
var WAZE = 'https://www.waze.com/ul?q=' +
  encodeURIComponent('Av. Providencia 1336, Providencia, Santiago') + '&navigate=yes';
GP.maps = MAPS; GP.waze = WAZE;

function opAgotado() {
  var d = (window.GP && GP.agotado) || {};
  return {
    mostrar:    d.mostrar    !== false,
    alFinal:    d.alFinal    !== false,
    flag:       d.flag       || 'Sin stock',
    avisar:     d.avisar     !== false,
    avisarTxt:  d.avisarTxt  || 'Avísame cuando llegue',
    avisarMedio: d.avisarMedio || 'whatsapp',
    avisarMsg:  d.avisarMsg   || 'Hola, avísenme cuando llegue {producto} (SKU {sku}). Gracias.',
    avisarSub:  d.avisarSub  || 'Déjanos tu correo y te escribimos apenas entre el próximo lote.',
    avisarOk:   d.avisarOk   || 'Listo. Te escribimos apenas llegue.',
    encargo:    d.encargo    !== false,
    encargoTxt: d.encargoTxt || 'Pídelo por encargo',
    encargoMsg: d.encargoMsg || 'Hola, quiero pedir por encargo {producto} (SKU {sku}). ¿Lo pueden conseguir?'
  };
}
function agotado(p) { return p && p.st !== null && p.st !== undefined && p.st <= 0; }
GP.agotadoP = agotado;

function wa(plantilla, p) {
  var msg = String(plantilla || '')
    .replace(/\{producto\}/g, p.n)
    .replace(/\{sku\}/g, p.sku || '')
    .replace(/\{url\}/g, location.origin + url(p));
  var num = (window.GP && GP.ajustes && GP.ajustes.wa) || '56965529189';
  return 'https://api.whatsapp.com/send/?phone=' + num + '&text=' + encodeURIComponent(msg);
}
function waEncargo(p) { return wa(opAgotado().encargoMsg, p); }
function waAviso(p)   { return wa(opAgotado().avisarMsg, p); }

/* Los botones que reemplazan al de comprar. En bloque para la ficha, apretados para la tarjeta. */
function botonesAgotado(p, chico) {
  var o = opAgotado(), h = '';
  if (o.avisar) {
    h += o.avisarMedio === 'correo'
      ? '<button class="btn btn--oro' + (chico ? ' btn--sm' : '') + ' btn--bloque" type="button" ' +
        'data-avisar="' + p.i + '">' + esc(o.avisarTxt) + '</button>'
      : '<a class="btn btn--oro' + (chico ? ' btn--sm' : '') + ' btn--bloque" target="_blank" rel="noopener" ' +
        'href="' + waAviso(p) + '">' + esc(o.avisarTxt) + '</a>';
  }
  if (o.encargo) {
    h += '<a class="btn btn--linea' + (chico ? ' btn--sm' : '') + ' btn--bloque"' +
         (o.avisar ? ' style="margin-top:8px"' : '') + ' target="_blank" rel="noopener" ' +
         'href="' + waEncargo(p) + '">' + esc(o.encargoTxt) + '</a>';
  }
  return h || '<span class="card__agotado">' + esc(o.flag) + '</span>';
}
GP.botonesAgotado = botonesAgotado;

/* Hueco de foto. Un recuadro vacío con el nombre de la tienda se lee como error; con el
   logo de la casa y una línea que diga qué pasa, se lee como una ficha en preparación.
   Es honesto: la foto no está porque el producto acaba de entrar desde Bsale. */
function sinFoto(p, grande) {
  var marca = p && p.b ? marcaLogo(p.b) : '';
  return '<div class="sinfoto' + (grande ? ' sinfoto--grande' : '') + '">' +
    (marca ? '<img class="sinfoto__logo" src="' + marca + '" alt="' + esc(p.b) + '" loading="lazy">'
           : '<span class="sinfoto__marca">' + esc((p && p.b) || 'Gold Perfumes') + '</span>') +
    '<span class="sinfoto__t">Foto en camino</span>' +
    (grande ? '<span class="sinfoto__s">Estamos fotografiando este perfume. Si quieres verlo antes, escríbenos y te mandamos fotos reales.</span>' : '') +
  '</div>';
}
GP.sinFoto = sinFoto;

/* El botón chico de la barra fija de la ficha. */
GP.botonAvisoFijo = function (p) {
  var o = opAgotado();
  if (!o.avisar) return '<a class="btn btn--oro" target="_blank" rel="noopener" href="' + waEncargo(p) + '">' +
    esc(o.encargoTxt) + '</a>';
  return o.avisarMedio === 'correo'
    ? '<button class="btn btn--oro" type="button" data-avisar="' + p.i + '">' + esc(o.avisarTxt) + '</button>'
    : '<a class="btn btn--oro" target="_blank" rel="noopener" href="' + waAviso(p) + '">' + esc(o.avisarTxt) + '</a>';
};

/* Ventana para dejar el correo. En la tienda va al formulario de contacto de
   Shopify, que le llega al correo del local; en la maqueta solo confirma. */
function avisame(id) {
  var p = IX[id]; if (!p) return;
  var o = opAgotado();
  var wrap = document.createElement('div');
  wrap.className = 'drawer abierto';
  wrap.innerHTML = '<div class="drawer__velo" data-cerrar-av></div>' +
    '<div class="drawer__panel" role="dialog" aria-label="Avísame cuando llegue">' +
      '<div class="drawer__tabs"><button class="dtab on" type="button">' + esc(o.avisarTxt) + '</button>' +
        '<button class="drawer__cerrar" type="button" data-cerrar-av aria-label="Cerrar">' +
        '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>' +
      '<div class="drawer__lista">' +
        '<div class="avis__prod">' +
          (foto(p) ? '<img src="' + foto(p) + '" alt="">' : '') +
          '<div><strong>' + esc(p.n) + '</strong>' +
            '<span>' + esc(meta(p)) + ' · ' + clp(p.p) + '</span></div>' +
        '</div>' +
        '<p class="avis__sub">' + esc(o.avisarSub) + '</p>' +
        '<form class="avis__form" id="avisForm">' +
          '<label class="avis__lab" for="avisMail">Tu correo</label>' +
          '<input type="email" id="avisMail" name="correo" required placeholder="tu@correo.cl" autocomplete="email">' +
          '<button class="btn btn--oro btn--bloque" type="submit" style="margin-top:12px">' +
            esc(o.avisarTxt) + '</button>' +
        '</form>' +
        '<p class="avis__ok" id="avisOk" hidden>' + esc(o.avisarOk) + '</p>' +
        '<p class="avis__alt">¿Prefieres que te escribamos por WhatsApp? ' +
          '<a href="' + waAviso(p) + '" target="_blank" rel="noopener">Pídelo por ahí</a>' +
          (o.encargo ? ' · o <a href="' + waEncargo(p) + '" target="_blank" rel="noopener">' +
            esc(o.encargoTxt.toLowerCase()) + '</a>' : '') + '</p>' +
      '</div></div>';
  document.body.appendChild(wrap);
  document.body.style.overflow = 'hidden';
  function cerrar() { wrap.remove(); document.body.style.overflow = ''; }
  wrap.addEventListener('click', function (e) { if (e.target.closest('[data-cerrar-av]')) cerrar(); });
  var f = wrap.querySelector('#avisForm');
  f.addEventListener('submit', function (e) {
    e.preventDefault();
    var correo = wrap.querySelector('#avisMail').value.trim();
    if (!correo) return;
    var boton = f.querySelector('button');
    boton.disabled = true; boton.textContent = 'Enviando…';

    /* En la tienda se envía el formulario nativo de Shopify, que es una navegación
       de verdad. Shopify rechaza con su verificación antibots los envíos hechos por
       fetch, y confirmar un aviso que nunca salió sería mentirle al visitante. */
    var nativo = document.getElementById('avisameForm');
    if (nativo) {
      document.getElementById('avisameCorreo').value = correo;
      document.getElementById('avisameProducto').value =
        p.n + ' · SKU ' + (p.sku || '') + ' · ' + location.origin + url(p);
      document.getElementById('avisameCuerpo').value =
        'Avísame cuando llegue: ' + p.n + ' (SKU ' + (p.sku || '') + ').\n' +
        'Correo del cliente: ' + correo + '\n' + location.origin + url(p);
      try { sessionStorage.setItem('gp:aviso', p.n); } catch (err) {}
      nativo.submit();
      return;
    }
    // maqueta: no hay tienda detrás, solo se confirma
    f.hidden = true;
    wrap.querySelector('#avisOk').hidden = false;
  });
}
GP.avisame = avisame;

/* Shopify devuelve a la página con ?contact_posted=true. Recién ahí se confirma. */
function confirmarAviso() {
  var enviado = /[?&]contact_posted=true/.test(location.search) || (window.GP && GP.avisoEnviado);
  if (!enviado) return;
  var prod = '';
  try { prod = sessionStorage.getItem('gp:aviso') || ''; sessionStorage.removeItem('gp:aviso'); } catch (e) {}
  var o = opAgotado();
  var t = document.createElement('div');
  t.className = 'avisoflash';
  t.innerHTML = '<b>' + esc(o.avisarOk) + '</b>' + (prod ? '<span>' + esc(prod) + '</span>' : '');
  document.body.appendChild(t);
  setTimeout(function () { t.classList.add('on'); }, 40);
  setTimeout(function () { t.classList.remove('on'); setTimeout(function () { t.remove(); }, 400); }, 6000);
}
GP.confirmarAviso = confirmarAviso;

function flags(p) {
  var f = [], e = equiv(p);
  if (p.ant && p.ant > p.p) f.push('<span class="flag flag--cyber cyb-solo-on">Cyber</span>');
  if (e) f.push('<span class="flag flag--eq">−' + e.pct + '% por ml</span>');
  else if (p.ins) f.push('<span class="flag flag--oro">Dupe</span>');
  if (p.te) f.push('<span class="flag flag--tester">Tester</span>');
  if (agotado(p)) f.push('<span class="flag flag--agotado">' + esc(opAgotado().flag) + '</span>');
  else if (p.st && p.st <= 3) f.push('<span class="flag flag--stock">Quedan ' + p.st + '</span>');
  return f.join('');
}

function card(p, op) {
  op = op || {};
  var e = equiv(p), img = foto(p);
  var esFav = FAV.indexOf(p.i) >= 0, esCmp = CMP.indexOf(p.i) >= 0;
  return '' +
  '<article class="card' + (agotado(p) ? ' agotado' : '') + '" data-id="' + p.i + '">' +
    '<a class="card__ver" href="' + url(p) + '" aria-label="' + esc(p.n) + '"></a>' +
    '<div class="card__fig">' +
      '<div class="card__flags">' + flags(p) + '</div>' +
      '<div class="card__tools">' +
        '<button class="ctool' + (esFav ? ' on' : '') + '" type="button" data-fav="' + p.i + '" aria-label="Guardar en favoritos" title="Guardar">' +
          '<svg viewBox="0 0 24 24"><path d="M12 20s-7.5-4.6-7.5-9.4A4.1 4.1 0 0 1 12 7.6a4.1 4.1 0 0 1 7.5 3C19.5 15.4 12 20 12 20Z"/></svg></button>' +
        '<button class="ctool' + (esCmp ? ' on' : '') + '" type="button" data-cmp="' + p.i + '" aria-label="Comparar" title="Comparar">' +
          '<svg viewBox="0 0 24 24"><path d="M4 7h7M4 12h7M4 17h7M16 5v14M13 8l3-3 3 3"/></svg></button>' +
      '</div>' +
      (img ? '<img src="' + img + '" alt="' + esc(p.n) + '" loading="lazy" width="240" height="240">'
           : sinFoto(p, false)) +
      '<button class="card__quick" type="button" data-quick="' + p.i + '">Vista rápida</button>' +
    '</div>' +
    '<div class="card__body">' +
      (p.b ? '<span class="card__marca">' + esc(p.b) + '</span>' : '') +
      '<h3 class="card__nom">' + esc(p.n) + '</h3>' +
      '<p class="card__meta">' + esc(meta(p)) + (p.ml ? ' · ' + clp(Math.round(p.p / p.ml)) + '/ml' : '') + '</p>' +
      '<div class="card__pie">' +
        '<div class="card__precio"><b>' + clp(p.p) + '</b>' +
          (p.ant && p.ant > p.p ? '<s>' + clp(p.ant) + '</s>' +
            '<em>−' + Math.round(100 * (1 - p.p / p.ant)) + '%</em>' : '') + '</div>' +
        (cuota(p.p) ? '<div class="card__cuota">' + cuota(p.p) + '</div>' : '') +
        (e && !op.sinEq
          ? '<div class="card__eq">Dupe de <b>' + esc(e.o.n.split(' ').slice(0, 4).join(' ')) + '</b> · el original sale ' + clp(Math.round(e.mlB)) + ' el ml</div>'
          : '') +
        (agotado(p)
          ? '<div class="card__agotado-cta">' + botonesAgotado(p, true) + '</div>'
          : '<button class="card__add" type="button" data-add="' + p.i + '">Agregar</button>') +
      '</div>' +
    '</div>' +
  '</article>';
}
GP.card = card;
GP.grid = function (lista, op) {
  op = op || {};
  var o = opAgotado();
  var l = o.mostrar ? lista.slice() : lista.filter(function (p) { return !agotado(p); });
  // los agotados siguen apareciendo, pero después de lo que sí se puede comprar
  if (o.alFinal && !op.sinOrdenar) {
    l = l.filter(function (p) { return !agotado(p); }).concat(l.filter(agotado));
  }
  return l.map(function (p) { return card(p, op); }).join('');
};

/* ---------- agregaciones ---------- */
function famTop(n, filtro) {
  var c = {};
  P.forEach(function (p) { if (!filtro || filtro(p)) (p.f || []).forEach(function (f) { c[f] = (c[f] || 0) + 1; }); });
  return Object.keys(c).sort(function (a, b) { return c[b] - c[a]; }).slice(0, n).map(function (f) { return { n: f, c: c[f] }; });
}
function marcaTop(n, filtro) {
  var c = {};
  P.forEach(function (p) { if (p.b && (!filtro || filtro(p))) c[p.b] = (c[p.b] || 0) + 1; });
  return Object.keys(c).sort(function (a, b) { return c[b] - c[a]; }).slice(0, n).map(function (m) { return { n: m, c: c[m] }; });
}
function notaTop(n, filtro) {
  var c = {};
  P.forEach(function (p) { if (!filtro || filtro(p)) notasDe(p).forEach(function (x) { c[x] = (c[x] || 0) + 1; }); });
  return Object.keys(c).sort(function (a, b) { return c[b] - c[a]; }).slice(0, n).map(function (x) { return { n: x, c: c[x] }; });
}
function marcaLogo(nombre) {
  var p = P.filter(function (x) { return x.b === nombre && x.logo; })[0];
  return p ? logo(p) : '';
}

/* De un texto libre como "Prada Paradoxe" o "Dior Homme Parfum 2025" saca la casa y
   devuelve su logotipo. Busca en TODOS los logos de Archivos, no solo en las marcas que
   vendemos: el original de un dupe casi nunca está en el catálogo —Prada no lo está— y
   ahí es justamente donde hace falta reconocer la casa. */
var CASAS_ORIGEN = null;
var ALIAS_ORIGEN = {
  'dior': 'christian-dior', 'christian dior': 'christian-dior',
  'jpg': 'jean-paul-gaultier', 'gaultier': 'jean-paul-gaultier',
  'ysl': 'yves-saint-laurent', 'saint laurent': 'yves-saint-laurent',
  'armani': 'giorgio-armani', 'emporio armani': 'giorgio-armani',
  'thierry mugler': 'mugler', 'mugler': 'mugler',
  'tommy hilfiger': 'tomy-hilfiger', 'viktor rolf': 'victor-rolf',
  'rabanne': 'paco-rabanne', 'montblanc': 'mont-blanc', 'boss': 'hugo-boss',
  'issey miyake': 'issey-miyake', 'parfums de marly': 'parfums-de-marly'
};
function logoDeTexto(txt) {
  if (!txt) return { url: '', marca: '' };
  var arch = (GP.archivos || {});
  if (!CASAS_ORIGEN) {
    var s = {};
    // los logos que existen en Archivos, con su nombre legible
    Object.keys(arch).forEach(function (k) {
      if (k.indexOf('marca:') !== 0) return;
      s[k.slice(6).replace(/-/g, ' ')] = k.slice(6);
    });
    P.forEach(function (x) { if (x.b && x.logo) s[sinAcento(x.b)] = null; });
    Object.keys(ALIAS_ORIGEN).forEach(function (k) {
      if (arch['marca:' + ALIAS_ORIGEN[k]]) s[k] = ALIAS_ORIGEN[k];
    });
    CASAS_ORIGEN = Object.keys(s).map(function (n) { return { n: n, slug: s[n] }; })
      .sort(function (a, b) { return b.n.length - a.n.length; });
  }
  var t = sinAcento(txt);
  for (var i = 0; i < CASAS_ORIGEN.length; i++) {
    var c = CASAS_ORIGEN[i];
    if (c.n.length < 4 || t.indexOf(c.n) < 0) continue;
    var url = c.slug ? (arch['marca:' + c.slug] || '') : marcaLogo(c.n);
    if (!url) {
      // el nombre vino del catálogo: se busca por el nombre tal cual está escrito
      var p2 = P.filter(function (x) { return x.b && sinAcento(x.b) === c.n && x.logo; })[0];
      url = p2 ? logo(p2) : '';
    }
    if (url) return { url: url, marca: c.n.replace(/\b\w/g, function (m) { return m.toUpperCase(); }) };
  }
  return { url: '', marca: '' };
}
GP.logoDeTexto = logoDeTexto;
function desde(filtro) {
  var l = P.filter(filtro).map(function (p) { return p.p; });
  return l.length ? Math.min.apply(null, l) : 0;
}
GP.famTop = famTop; GP.marcaTop = marcaTop; GP.notaTop = notaTop;
GP.marcaLogo = marcaLogo; GP.desde = desde; GP.logo = logo; GP.amb = amb;

/* ============================================================
   MEGAMENÚ CON VISTA PREVIA
   ============================================================ */
var PREVS = {};
function regPrev(clave, lista, titulo, href) { PREVS[clave] = { l: lista, t: titulo, h: href }; }

function miniCard(p) {
  return '<a class="mprev__it" href="' + url(p) + '">' +
    (foto(p) ? '<img src="' + foto(p) + '" alt="" loading="lazy">' : '<span></span>') +
    '<span class="mprev__t">' + esc(p.n) + '</span>' +
    '<span class="mprev__p">' + clp(p.p) + '</span></a>';
}
function preview(lista, titulo, href) {
  var l = lista.filter(function (p) { return p.img; }).slice(0, 4);
  return '<div class="mprev__cab"><b>' + esc(titulo) + '</b><a href="' + href + '">Ver todo →</a></div>' +
    '<div class="mprev__grid">' + l.map(miniCard).join('') + '</div>';
}
function megaCol(titulo, items) {
  return '<div class="mega__col"><h4>' + esc(titulo) + '</h4><ul>' +
    items.map(function (it) {
      return '<li><a href="' + it.href + '"' + (it.prev ? ' data-prev="' + esc(it.prev) + '"' : '') + '>' +
        (it.logo ? '<img class="mega__logo" src="' + it.logo + '" alt="" loading="lazy">' : '') +
        '<span>' + esc(it.t) + '</span>' + (it.c ? '<b>' + it.c + '</b>' : '') + '</a></li>';
    }).join('') + '</ul></div>';
}
function megaPie(g) {
  var q = g ? '&g=' + encodeURIComponent(g) : '';
  return '<div class="mega__pie"><span>Lo más buscado</span>' +
    notaTop(7, g ? function (p) { return p.g === g; } : null).map(function (n) {
      return '<a class="mchip" href="' + GP.T({nota:n.n}) + q + '">' + esc(n.n) + '</a>';
    }).join('') +
    '<a class="mchip mchip--cta" href="/pages/test">¿No sabes cuál? Haz el test →</a></div>';
}
function megaCaja(cols, primerPrev, g) {
  return '<div class="mega"><div class="cont"><div class="mega__in">' + cols +
    '<div class="mega__prev mprev" data-prev-box>' +
      preview(PREVS[primerPrev].l, PREVS[primerPrev].t, PREVS[primerPrev].h) + '</div>' +
  '</div>' + megaPie(g || '') + '</div></div>';
}


/* ---------- MARCAS, agrupadas por abecedario ----------
   El cliente pidió el menú de marcas arriba y ordenado alfabéticamente, en pares de
   letras. Cada grupo muestra sus casas con el número de fragancias, y al pasar el mouse
   se previsualiza lo más caro de esa marca. */
var PARES = [['A','B'],['C','D'],['E','F'],['G','H'],['I','J'],['K','L'],['M','N'],
             ['O','P'],['Q','R'],['S','T'],['U','V'],['W','X'],['Y','Z'],['0','9']];
function letraDe(nombre) {
  var c = sinAcento(nombre).charAt(0).toUpperCase();
  return /[0-9]/.test(c) ? '#' : c;
}
function megaMarcas() {
  var cuenta = {};
  P.forEach(function (p) { if (p.b && GP.visible(p)) cuenta[p.b] = (cuenta[p.b] || 0) + 1; });
  var marcas = Object.keys(cuenta).sort(function (a, b) {
    return sinAcento(a).localeCompare(sinAcento(b), 'es');
  });
  var grupos = PARES.map(function (par) {
    var dentro = marcas.filter(function (m) {
      var l = letraDe(m);
      return par[0] === '0' ? l === '#' : (l >= par[0] && l <= par[1]);
    });
    return { par: par, marcas: dentro };
  }).filter(function (g) { return g.marcas.length; });

  /* Contraído por pedido del cliente: se abre con los intervalos de iniciales y las
     casas del intervalo elegido; 88 marcas de golpe eran un muro. */
  var primer = '';
  var letras = '', listas = '';
  grupos.forEach(function (g, i) {
    var rotulo = g.par[0] === '0' ? '0 – 9' : g.par[0] + ' – ' + g.par[1];
    letras += '<button class="mletra' + (i === 0 ? ' on' : '') + '" type="button" data-letra="' + i + '">' +
      '<span>' + rotulo + '</span><b>' + g.marcas.length + '</b></button>';

    var items = g.marcas.map(function (m) {
      var k = 'mk' + sinAcento(m).replace(/[^a-z0-9]/g, '');
      regPrev(k, P.filter(function (p) { return p.b === m; }).sort(function (a, b) { return b.p - a.p; }),
        m, T({m:m}));
      if (!primer) primer = k;
      // La URL se arma aparte para que el traductor de rutas del tema la reconozca
      // (busca el literal T({m:m}), no dentro del markup).
      var href = T({m:m});
      return '<li><a href="' + href + '" data-prev="' + esc(k) + '">' +
        '<span>' + esc(m) + '</span><b>' + cuenta[m] + '</b></a></li>';
    }).join('');
    listas += '<ul class="mega__casas' + (i === 0 ? ' on' : '') + '" data-lista="' + i + '">' + items + '</ul>';
  });

  return '<div class="mega mega--marcas"><div class="cont"><div class="mega__in mega__in--marcas">' +
    '<div class="mega__letras">' + letras + '</div>' +
    '<div class="mega__listas">' + listas + '</div>' +
    '<div class="mega__prev mprev" data-prev-box>' +
    preview(PREVS[primer].l, PREVS[primer].t, PREVS[primer].h) + '</div></div>' +
    '<div class="mega__pie"><span>' + marcas.length + ' casas en vitrina</span>' +
    '<a class="mchip mchip--cta" href="/collections/catalogo">Ver el catálogo completo →</a></div></div></div>';
}

/* ---------- CATEGORÍAS ---------- */
function megaCategorias() {
  var CATS = [
    { t: 'Hombre',    h: '/collections/hombre',  f: function (p) { return p.g === 'Hombre'; } },
    { t: 'Mujer',     h: '/collections/mujer',   f: function (p) { return p.g === 'Mujer'; } },
    { t: 'Unisex',    h: '/collections/unisex',  f: function (p) { return p.g === 'Unisex'; } },
    { t: 'Árabes',    h: '/collections/perfumes-arabes',           f: function (p) { return p.k === 'arabe'; } },
    { t: 'Diseñador', h: '/collections/disenador',        f: function (p) { return p.k === 'disenador'; } },
    { t: 'Nicho',     h: '/collections/nicho',          f: function (p) { return p.k === 'nicho'; } }
  ];
  var primer = '';
  var items = CATS.map(function (c) {
    var k = 'cat' + sinAcento(c.t).replace(/[^a-z]/g, '');
    regPrev(k, P.filter(function (p) { return c.f(p) && GP.visible(p); }).sort(function (a, b) { return b.p - a.p; }), c.t, c.h);
    if (!primer) primer = k;
    return { t: c.t, c: P.filter(function (p) { return c.f(p) && GP.visible(p); }).length, prev: k, href: c.h };
  });
  var extra = [
    { t: 'Testers', c: P.filter(function (p) { return p.te && GP.visible(p); }).length, href: '/collections/testers' },
    { t: 'Body mist y splash', c: P.filter(function (p) { return p.fo === 'mist' && GP.visible(p); }).length, href: '/collections/body-mist' },
    { t: 'Dupes declarados', c: P.filter(function (p) { return p.ins && GP.visible(p); }).length, href: '/collections/dupes' },
    { t: 'Bajo $20.000', c: P.filter(function (p) { return p.p < 20000 && GP.visible(p); }).length, href: T({max:20000}) }
  ];
  return megaCaja(megaCol('Categorías', items) + megaCol('Atajos', extra) +
    megaCol('Por aroma', famTop(6).map(function (f) {
      return { t: f.n, c: f.c, href: T({fam:f.n}) };
    })), primer, '');
}

function megaGenero(g) {
  var base = function (p) { return p.g === g && p.fo === 'perfume'; };
  var qg = encodeURIComponent(g);
  var fams = famTop(6, base).map(function (f) {
    var k = 'g' + g + 'f' + f.n;
    regPrev(k, P.filter(function (p) { return base(p) && (p.f || []).indexOf(f.n) >= 0; }).sort(function (a, b) { return b.p - a.p; }),
      f.n + ' para ' + g.toLowerCase(), T({g:g, fam:f.n}));
    return { t: f.n, c: f.c, prev: k, href: T({g:g, fam:f.n}) };
  });
  var marcas = marcaTop(6, base).map(function (m) {
    var k = 'g' + g + 'm' + m.n;
    regPrev(k, P.filter(function (p) { return base(p) && p.b === m.n; }).sort(function (a, b) { return b.p - a.p; }),
      m.n, T({m:m.n}));
    return { t: m.n, c: m.c, prev: k, logo: marcaLogo(m.n), href: T({m:m.n}) };
  });
  var kN = 'g' + g + 'nuevo', kB = 'g' + g + 'barato';
  regPrev(kN, P.filter(base).sort(function (a, b) { return b.i - a.i; }), 'Recién llegados', T({g:g, orden:'nuevo'}));
  regPrev(kB, P.filter(function (p) { return base(p) && p.p < 25000; }).sort(function (a, b) { return a.p - b.p; }), 'Bajo $25.000', T({g:g, max:25000}));
  var cols = megaCol('Por aroma', fams) + megaCol('Por marca', marcas) + megaCol('Atajos', [
    { t: 'Recién llegados', prev: kN, href: T({g:g, orden:'nuevo'}) },
    { t: 'Bajo $25.000', c: P.filter(function (p) { return base(p) && p.p < 25000; }).length, prev: kB, href: T({g:g, max:25000}) },
    { t: 'Testers', c: P.filter(function (p) { return p.g === g && p.te; }).length, href: '/collections/testers' },
    { t: 'Body mist y splash', c: P.filter(function (p) { return p.g === g && p.fo === 'mist'; }).length, href: '/collections/body-mist' },
    { t: 'Ver todo ' + g.toLowerCase(), c: P.filter(function (p) { return p.g === g; }).length, href: T({g:g}) }
  ]);
  return megaCaja(cols, fams[0].prev, g);
}

function megaArabes() {
  var base = function (p) { return p.k === 'arabe'; };
  var casas = marcaTop(7, base).map(function (m) {
    var k = 'am' + m.n;
    regPrev(k, P.filter(function (p) { return base(p) && p.b === m.n; }).sort(function (a, b) { return b.p - a.p; }), m.n, T({m:m.n}));
    return { t: m.n, c: m.c, prev: k, logo: marcaLogo(m.n), href: T({m:m.n}) };
  });
  var fams = famTop(6, base).map(function (f) {
    var k = 'af' + f.n;
    regPrev(k, P.filter(function (p) { return base(p) && (p.f || []).indexOf(f.n) >= 0; }), f.n, T({k:'arabe', fam:f.n}));
    return { t: f.n, c: f.c, prev: k, href: T({k:'arabe', fam:f.n}) };
  });
  regPrev('aref', P.filter(function (p) { return p.ins; }).sort(function (a, b) { return b.p - a.p; }), 'Dupes declarados', '/collections/dupes');
  var cols = megaCol('Las casas', casas) + megaCol('Por aroma', fams) + megaCol('Cómo comprar', [
    { t: 'Dupes declarados', c: P.filter(function (p) { return p.ins; }).length, prev: 'aref', href: '/collections/dupes' },
    { t: 'Bajo $20.000', c: P.filter(function (p) { return base(p) && p.p < 20000; }).length, href: T({k:'arabe', max:20000}) },
    { t: 'La guía de árabes', href: '/collections/perfumes-arabes' },
    { t: 'Tabla de dupes', href: '/collections/dupes' },
    { t: 'Ver las ' + P.filter(base).length, href: '/collections/perfumes-arabes' }
  ]);
  return megaCaja(cols, casas[0].prev);
}

function megaDisenador() {
  var base = function (p) { return p.k === 'disenador' && p.fo === 'perfume'; };
  var casas = marcaTop(8, base).map(function (m) {
    var k = 'dm' + m.n;
    regPrev(k, P.filter(function (p) { return p.b === m.n; }).sort(function (a, b) { return b.p - a.p; }), m.n, T({m:m.n}));
    return { t: m.n, c: m.c, prev: k, logo: marcaLogo(m.n), href: T({m:m.n}) };
  });
  var fams = famTop(6, base).map(function (f) {
    var k = 'df' + f.n;
    regPrev(k, P.filter(function (p) { return base(p) && (p.f || []).indexOf(f.n) >= 0; }), f.n, T({k:'disenador', fam:f.n}));
    return { t: f.n, c: f.c, prev: k, href: T({k:'disenador', fam:f.n}) };
  });
  regPrev('dtester', P.filter(function (p) { return p.te; }).sort(function (a, b) { return b.p - a.p; }), 'Testers', '/collections/testers');
  var cols = megaCol('Las casas', casas) + megaCol('Por aroma', fams) + megaCol('Atajos', [
    { t: 'Testers', c: P.filter(function (p) { return p.te; }).length, prev: 'dtester', href: '/collections/testers' },
    { t: 'Bajo $30.000', c: P.filter(function (p) { return base(p) && p.p < 30000; }).length, href: T({k:'disenador', max:30000}) },
    { t: 'Body mist y splash', c: P.filter(function (p) { return p.fo === 'mist'; }).length, href: '/collections/body-mist' },
    { t: 'La página de diseñador', href: '/collections/disenador' }
  ]);
  return megaCaja(cols, casas[0].prev);
}

function megaAlta() {
  var nicho = function (p) { return p.k === 'nicho' && p.fo === 'perfume'; };
  var casas = marcaTop(7, nicho).map(function (m) {
    var k = 'nm' + m.n;
    regPrev(k, P.filter(function (p) { return p.b === m.n; }).sort(function (a, b) { return b.p - a.p; }), m.n, T({m:m.n}));
    return { t: m.n, c: m.c, prev: k, logo: marcaLogo(m.n), href: T({m:m.n}) };
  });
  var TR = [[50000, 100000], [100000, 200000], [200000, 1e9]];
  var tramos = TR.map(function (t, i) {
    var k = 'tr' + i, rot = t[1] < 1e9 ? clp(t[0]) + ' a ' + clp(t[1]) : 'Sobre ' + clp(t[0]);
    var href = T({min:t[0], max:(t[1] < 1e9 ? t[1] : 0)});
    regPrev(k, P.filter(function (p) { return p.p >= t[0] && p.p < t[1]; }).sort(function (a, b) { return a.p - b.p; }), rot, href);
    return { t: rot, c: P.filter(function (p) { return p.p >= t[0] && p.p < t[1]; }).length, prev: k, href: href };
  });
  var cols = megaCol('Casas de nicho', casas) + megaCol('Por presupuesto', tramos) + megaCol('Atajos', [
    { t: 'Testers de nicho', c: P.filter(function (p) { return p.te && p.p >= 50000; }).length, href: '/collections/testers' },
    { t: 'Solo nicho', c: P.filter(nicho).length, href: '/collections/nicho' },
    { t: 'Lo más caro de la vitrina', href: T({orden:'desc'}) },
    { t: 'La página de nicho', href: '/collections/nicho' }
  ]);
  return megaCaja(cols, casas[0].prev);
}

/* ============================================================
   CABECERA
   ============================================================ */
var LOGO = (D.archivos || {})['logo-gold'] || '';
var CYB = window.GP.cyber || {};

/* El icono de la cabecera apuntaba a "#" y no llevaba a ninguna parte. La dirección
   sale de routes.account_url, que con las cuentas nuevas de Shopify redirige al portal. */
function cuentaUrl() { return (window.GP.rutas && window.GP.rutas.cuenta) || '/account'; }
function hayCliente() { return !!window.GP.cliente; }

function cabecera(activo) {
  var est = estadoLocal();
  var tira = ['<b><i>◆</i> Envío gratis sobre ' + clp(UMBRAL_ENVIO) + ' en RM y ' + clp(UMBRAL_REGIONES) + ' en regiones</b>',
    '<b><i>◆</i> ' + CUOTAS + ' cuotas sin interés pagando con ' + MEDIOS_CUOTAS.map(function(m){return m.n;}).join(' y ') + '</b>',
    '<b><i>◆</i> Retiro gratis en ' + DIR + '</b>',
    '<b><i>◆</i> Perfumes 100% originales, distribuidor autorizado</b>',
    '<b><i>◆</i> RM entre 24 y 72 horas · regiones 2 a 6 días hábiles</b>'].join('');

  var nav = [
    { t: 'Marcas', h: '/collections/catalogo', mega: megaMarcas(), id: 'marcas' },
    { t: 'Categorías', h: '/collections/catalogo', mega: megaCategorias(), id: 'categorias' },
    { t: 'El local', h: '/pages/el-local', id: 'local' },
    { t: 'Test', h: '/pages/test', id: 'quiz' },
    { t: 'Ofertas', h: '/collections/ofertas', id: 'ofertas' },
    { t: CYB.menu || 'Cyber', h: '/collections/' + (CYB.coleccion || 'ofertas'), id: 'cyber', cyber: true }
  ];

  return '' +
  GP.cyberBarra() +
  '<div class="tira"><div class="tira__pista"><div class="tira__g">' + tira + '</div><div class="tira__g" aria-hidden="true">' + tira + '</div></div></div>' +
  '<header class="cab" id="cab">' +
    '<div class="cont">' +
      '<div class="cab__fila">' +
        '<button class="icobtn hamb" type="button" id="abrirMenu" aria-label="Abrir menú">' +
          '<svg viewBox="0 0 24 24"><path d="M3 6h18M3 12h18M3 18h18"/></svg></button>' +
        '<a class="cab__logo" href="/"><img src="' + LOGO + '" alt="Gold Perfumes" width="140" height="46"></a>' +
        '<div class="busca busca--esc">' +
          '<div class="busca__campo">' +
            '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>' +
            '<input type="search" id="q" placeholder="Busca por perfume, marca o nota olfativa" autocomplete="off" aria-label="Buscar">' +
            '<button class="busca__dado" type="button" id="dado" title="Sorpréndeme" aria-label="Sorpréndeme">' +
              '<svg viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="3"/><circle cx="9" cy="9" r="1.4" fill="currentColor" stroke="none"/><circle cx="15" cy="15" r="1.4" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1.4" fill="currentColor" stroke="none"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="busca__res" id="qres" hidden></div>' +
        '</div>' +
        '<a class="local-pill' + (est.abierto ? ' on' : '') + '" href="/pages/el-local" title="' + esc(est.texto) + '">' +
          '<i></i><span><b>' + esc(est.corto) + '</b>' + esc(est.detalle) + '</span></a>' +
        '<div class="cab__acc">' +
          '<a class="icobtn" href="https://api.whatsapp.com/send/?phone=' + WA + '" aria-label="Escribir por WhatsApp" target="_blank" rel="noopener">' +
            '<svg viewBox="0 0 24 24"><path d="M12 21a9 9 0 1 0-7.7-4.3L3 21l4.5-1.2A9 9 0 0 0 12 21Z"/></svg></a>' +
          '<a class="icobtn' + (hayCliente() ? ' on' : '') + '" href="' + cuentaUrl() + '" aria-label="' +
            (hayCliente() ? 'Mi cuenta' : 'Entrar a mi cuenta') + '" title="' +
            (hayCliente() ? 'Mi cuenta' : 'Entrar a mi cuenta') + '">' +
            '<svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="3.6"/><path d="M4.5 20a7.5 7.5 0 0 1 15 0"/></svg></a>' +
          '<button class="icobtn" type="button" id="abrirFav" aria-label="Favoritos">' +
            '<svg viewBox="0 0 24 24"><path d="M12 20s-7.5-4.6-7.5-9.4A4.1 4.1 0 0 1 12 7.6a4.1 4.1 0 0 1 7.5 3C19.5 15.4 12 20 12 20Z"/></svg>' +
            '<span class="icobtn__n" id="nfav" data-n="0">0</span></button>' +
          '<button class="icobtn" type="button" id="abrirCarro" aria-label="Ver carro">' +
            '<svg viewBox="0 0 24 24"><path d="M6 8h12l-1 12H7L6 8Z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>' +
            '<span class="icobtn__n" id="ncarro" data-n="0">0</span></button>' +
        '</div>' +
      '</div>' +
    '</div>' +
    '<nav class="nav" aria-label="Principal"><div class="cont"><ul class="nav__ul">' +
      nav.map(function (n) {
        return '<li class="nav__li' + (n.cyber ? ' nav__li--cyber' : '') + '"><a class="nav__a' +
          (n.id && n.id === activo ? ' nav__a--of' : '') + (n.id === 'quiz' ? ' nav__a--test' : '') +
          (n.cyber ? ' nav__a--cyber' : '') + '" href="' + n.h + '">' + esc(n.t) + '</a>' + (n.mega || '') + '</li>';
      }).join('') +
    '</ul></div></nav>' +
  '</header>' + menuMovil(est);
}

function menuMovil(est) {
  /* Mismo orden que el menú de escritorio, el que pidió el cliente:
     Marcas (por abecedario) · Categorías · El local · Test · Ofertas. */
  var cuenta = {};
  P.forEach(function (p) { if (p.b && GP.visible(p)) cuenta[p.b] = (cuenta[p.b] || 0) + 1; });
  var marcas = Object.keys(cuenta).sort(function (a, b) { return sinAcento(a).localeCompare(sinAcento(b), 'es'); });
  var letras = PARES.map(function (par) {
    var dentro = marcas.filter(function (m) {
      var l = letraDe(m);
      return par[0] === '0' ? l === '#' : (l >= par[0] && l <= par[1]);
    });
    return { rotulo: par[0] === '0' ? '0 – 9' : par[0] + ' – ' + par[1], marcas: dentro };
  }).filter(function (g) { return g.marcas.length; });
  var htmlMarcas = letras.map(function (g) {
    return '<b class="macc__letra">' + g.rotulo + '</b>' +
      g.marcas.map(function (m) { return '<a href="' + T({m:m}) + '">' + esc(m) + '<b>' + cuenta[m] + '</b></a>'; }).join('');
  }).join('') + '<a href="' + '/collections/catalogo' + '" class="macc__todo">Ver el catálogo completo →</a>';

  var cats = [
    { t: 'Hombre', h: '/collections/hombre', c: P.filter(function (p) { return p.g === 'Hombre' && GP.visible(p); }).length },
    { t: 'Mujer', h: '/collections/mujer', c: P.filter(function (p) { return p.g === 'Mujer' && GP.visible(p); }).length },
    { t: 'Unisex', h: '/collections/unisex', c: P.filter(function (p) { return p.g === 'Unisex' && GP.visible(p); }).length },
    { t: 'Perfumes árabes', h: '/collections/perfumes-arabes', c: P.filter(function (p) { return p.k === 'arabe' && GP.visible(p); }).length },
    { t: 'Casas de diseñador', h: '/collections/disenador', c: P.filter(function (p) { return p.k === 'disenador' && GP.visible(p); }).length },
    { t: 'Perfumes de nicho', h: '/collections/nicho', c: P.filter(function (p) { return p.k === 'nicho' && GP.visible(p); }).length }
  ];
  var htmlCats = cats.map(function (x) { return '<a href="' + x.h + '">' + esc(x.t) + '<b>' + x.c + '</b></a>'; }).join('') +
    '<a href="' + '/collections/catalogo' + '" class="macc__todo">Ver el catálogo completo →</a>';

  var sec = [
    { t: 'Marcas', html: htmlMarcas, sub: marcas.length + ' casas por abecedario' },
    { t: 'Categorías', html: htmlCats, sub: 'Hombre, mujer, unisex, árabes, diseñador y nicho' }
  ];
  return '<div class="movil" id="movil"><div class="movil__velo" data-cerrar-menu></div><div class="movil__panel">' +
    '<div class="movil__top"><img src="' + LOGO + '" alt="Gold Perfumes">' +
      '<button class="icobtn" type="button" data-cerrar-menu aria-label="Cerrar menú">' +
      '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>' +
    '<div class="busca" style="padding:14px 18px 6px">' +
      '<div class="busca__campo"><svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>' +
      '<input type="search" id="qm" placeholder="Buscar perfume, marca o nota" autocomplete="off" aria-label="Buscar"></div>' +
      '<div class="busca__res" id="qresm" hidden></div></div>' +
    '<a class="movil__local' + (est.abierto ? ' on' : '') + '" href="/pages/el-local"><i></i>' +
      '<span><b>' + esc(est.corto) + '</b> ' + esc(est.detalle) + '<small>' + DIR + '</small></span></a>' +
    '<nav class="movil__nav">' +
      sec.map(function (s, k) {
        return '<div class="macc">' +
          '<button class="macc__bt" type="button" data-macc="' + k + '" aria-expanded="false"><span>' + esc(s.t) +
            '<small>' + esc(s.sub) + '</small></span>' +
            '<svg viewBox="0 0 24 24"><path d="m6 9 6 6 6-6"/></svg></button>' +
          '<div class="macc__cu" id="macc' + k + '" hidden>' + s.html + '</div></div>';
      }).join('') +
      '<a class="movil__link" href="/pages/el-local">El local de Providencia<small>Horarios, cómo llegar y retiro de pedidos</small></a>' +
      '<a class="movil__link" href="/pages/test">Test: encuentra tu perfume<small>Cuatro preguntas y te damos cuatro opciones</small></a>' +
      '<a class="movil__link" href="/collections/ofertas">Ofertas<small>Los perfumes con descuento</small></a>' +
      '<a class="movil__link" href="' + cuentaUrl() + '">' + (hayCliente() ? 'Mi cuenta' : 'Entrar a mi cuenta') +
        '<small>' + (hayCliente() ? 'Tus pedidos y tus datos' : 'Revisa tus pedidos y guarda tus datos') + '</small></a>' +
    '</nav>' +
    '<div class="movil__pie">' + DIR + '<br>Lunes a viernes 10:30 a 19:30 · sábado 11:00 a 15:00<br>' +
      '<a href="https://api.whatsapp.com/send/?phone=' + WA + '" target="_blank" rel="noopener">+56 9 6552 9189</a></div>' +
  '</div></div>';
}

/* ============================================================
   PIE
   ============================================================ */
function pie() {
  return '<footer class="pie"><div class="cont">' +
    '<div class="pie__grid">' +
      '<div>' +
        '<img class="pie__logo" src="' + LOGO + '" alt="Gold Perfumes">' +
        '<p style="font-size:13.5px;line-height:1.65;max-width:34ch;margin:0">Una perfumería donde compartimos el amor por las fragancias con cada uno de nuestros clientes. Perfumes originales de distribuidores autorizados en Chile.</p>' +
        '<div class="pie__redes">' +
          '<a href="https://www.instagram.com/goldperfumes/" target="_blank" rel="noopener" aria-label="Instagram"><svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.2" cy="6.8" r=".9" fill="currentColor" stroke="none"/></svg></a>' +
          '<a href="https://api.whatsapp.com/send/?phone=' + WA + '" target="_blank" rel="noopener" aria-label="WhatsApp"><svg viewBox="0 0 24 24"><path d="M12 21a9 9 0 1 0-7.7-4.3L3 21l4.5-1.2A9 9 0 0 0 12 21Z"/></svg></a>' +
          '<a href="mailto:contacto@goldperfumes.cl" aria-label="Correo"><svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg></a>' +
        '</div>' +
      '</div>' +
      '<div><h4>Catálogo</h4><ul>' +
        '<li><a href="/collections/hombre">Hombre</a></li><li><a href="/collections/mujer">Mujer</a></li>' +
        '<li><a href="/collections/unisex">Unisex</a></li><li><a href="/collections/perfumes-arabes">Perfumes árabes</a></li>' +
        '<li><a href="/collections/disenador">Diseñador</a></li><li><a href="/collections/nicho">Perfumes de nicho</a></li>' +
      '</ul></div>' +
      '<div><h4>Ayuda</h4><ul>' +
        '<li><a href="/pages/test">Encuentra tu perfume</a></li>' +
        '<li><a href="/pages/comparador">Comparador</a></li>' +
        '<li><a href="/pages/el-local">El local y el retiro</a></li>' +
        '<li><a href="/pages/el-local#faq">Preguntas frecuentes</a></li>' +
        '<li><a href="https://api.whatsapp.com/send/?phone=' + WA + '" target="_blank" rel="noopener">Escríbenos</a></li>' +
        ((window.GP && GP.politicas) || []).map(function (x) {
          return '<li><a href="' + x.h + '">' + esc(x.t) + '</a></li>';
        }).join('') +
      '</ul></div>' +
      '<div><h4>La tienda</h4><ul>' +
        '<li><a href="' + MAPS + '" target="_blank" rel="noopener">' + DIR + '</a>' +
          ' · <a href="' + WAZE + '" target="_blank" rel="noopener">Waze</a></li>' +
        '<li>Metro Manuel Montt, Providencia</li>' +
        '<li>Lunes a viernes 10:30 a 19:30</li><li>Sábado 11:00 a 15:00</li>' +
        '<li><a href="https://api.whatsapp.com/send/?phone=' + WA + '" target="_blank" rel="noopener">+56 9 6552 9189</a></li>' +
        '<li><a href="mailto:contacto@goldperfumes.cl">contacto@goldperfumes.cl</a></li>' +
      '</ul>' +
      '<div class="pie__pagos"><span>Webpay</span><span>Flow</span><span>Venti</span><span>Débito</span><span>Crédito</span><span>Transferencia</span></div>' +
      '</div>' +
    '</div>' +
    '<div class="pie__legal"><span>© 2018–2026 Gold Perfumes</span>' +
      '<span>Envío gratis sobre ' + clp(UMBRAL_ENVIO) + ' en RM y ' + clp(UMBRAL_REGIONES) + ' en regiones · 24 a 72 horas</span>' +
      '<span class="pie__ref">Las imágenes de ambiente y de categoría son referenciales.</span></div>' +
  '</div></footer>' +
  '<a class="wa" href="https://api.whatsapp.com/send/?phone=' + WA + '" target="_blank" rel="noopener" aria-label="Escríbenos por WhatsApp">' +
    '<svg viewBox="0 0 32 32"><path d="M16 3a13 13 0 0 0-11.1 19.8L3 29l6.4-1.8A13 13 0 1 0 16 3Zm7.5 18.3c-.3.9-1.8 1.7-2.5 1.8-.6.1-1.4.1-2.3-.1a19 19 0 0 1-8.3-7.2c-.6-.9-1.4-2.3-1.4-3.7s.7-2.1 1-2.4c.3-.3.6-.4.8-.4h.6c.2 0 .5-.1.7.5l1 2.4c.1.2.1.4 0 .6l-.4.6-.4.4c-.1.2-.3.4-.1.7.2.3.8 1.4 1.8 2.3 1.2 1.1 2.2 1.4 2.5 1.6.3.1.5.1.7-.1l1-1.2c.2-.3.4-.2.7-.1l2.3 1.1c.3.2.6.3.6.4.1.2.1.7-.2 1.5Z"/></svg></a>';
}

/* ============================================================
   DRAWERS + COMPARADOR FLOTANTE
   ============================================================ */
function drawerHTML() {
  return '<div class="drawer" id="drawer">' +
    '<div class="drawer__velo" data-cerrar-carro></div>' +
    '<div class="drawer__panel" role="dialog" aria-label="Tu carro">' +
      '<div class="drawer__tabs">' +
        '<button class="dtab on" type="button" data-tab="carro">Carro <span id="dnum"></span></button>' +
        '<button class="dtab" type="button" data-tab="fav">Favoritos <span id="dnumf"></span></button>' +
        '<button class="drawer__cerrar" type="button" data-cerrar-carro aria-label="Cerrar">' +
        '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
      '</div>' +
      '<div data-panel="carro">' +
        '<div class="prog" id="prog"></div>' +
        '<div class="drawer__lista" id="dlista"></div>' +
        '<div class="drawer__cruz" id="dcruz"></div>' +
        '<div class="drawer__pie" id="dpie"></div>' +
      '</div>' +
      '<div data-panel="fav" hidden><div class="drawer__lista" id="dfav"></div></div>' +
    '</div></div>' +
    '<div class="cmpbar" id="cmpbar" hidden><div class="cont"><div class="cmpbar__in">' +
      '<span class="cmpbar__t">Comparar</span><div class="cmpbar__l" id="cmpl"></div>' +
      '<a class="btn btn--oro btn--sm" id="cmpir" href="/pages/comparador">Ver comparación</a>' +
      '<button class="cmpbar__x" type="button" id="cmpclear" aria-label="Vaciar comparador">Vaciar</button>' +
    '</div></div></div>' +
    '<div class="toast" id="toast" role="status" aria-live="polite"></div>';
}

function abrirDrawer(tab) {
  $('#drawer').classList.add('abierto');
  document.body.style.overflow = 'hidden';
  if (tab) verTab(tab);
}
function cerrarDrawer() { $('#drawer').classList.remove('abierto'); document.body.style.overflow = ''; }
function verTab(t) {
  $$('.dtab').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-tab') === t); });
  $$('[data-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== t; });
}

var tToast;
function toast(txt) {
  var t = $('#toast'); if (!t) return;
  t.textContent = txt; t.classList.add('ver');
  clearTimeout(tToast); tToast = setTimeout(function () { t.classList.remove('ver'); }, 2600);
}
GP.toast = toast;

function pintarCarro() {
  var n = unidades(), tot = totalCarro();
  var nc = $('#ncarro'); if (nc) { nc.textContent = n; nc.setAttribute('data-n', n); }
  var dn = $('#dnum'); if (dn) dn.textContent = n ? '(' + n + ')' : '';

  var prog = $('#prog');
  if (prog) {
    // La barra mide contra el umbral de regiones, que es el tramo completo; el hito
    // de RM queda marcado en el camino.
    var pct = Math.min(100, Math.round(100 * tot / UMBRAL_REGIONES));
    var falta = UMBRAL_ENVIO - tot;
    var faltaReg = UMBRAL_REGIONES - tot;
    prog.innerHTML =
      // Los dos umbrales quedan a la vista siempre: antes, apenas el carro tenía algo,
      // "para el envío gratis" no decía cuál de los dos ni cuánto faltaba para regiones.
      '<p class="prog__txt">' + (tot === 0
        ? 'Envío gratis desde <b>' + clp(UMBRAL_ENVIO) + '</b> en RM y <b>' + clp(UMBRAL_REGIONES) + '</b> en regiones.'
        : (falta > 0
            ? 'Te faltan <b>' + clp(falta) + '</b> para el envío gratis en RM.'
            : (faltaReg > 0
                ? 'Envío gratis en RM. Te faltan <b>' + clp(faltaReg) + '</b> para que también sea gratis a regiones.'
                : 'Listo: <b>tu envío es gratis</b> a todo Chile.'))) + '</p>' +
      '<div class="prog__barra"><i style="width:' + pct + '%"></i></div>' +
      '<div class="prog__hitos">' +
        '<span' + (falta > 0 ? '' : ' class="on"') + '>RM ' + clp(UMBRAL_ENVIO) + '</span>' +
        '<span' + (faltaReg > 0 ? '' : ' class="on"') + '>Regiones ' + clp(UMBRAL_REGIONES) + '</span></div>';
  }

  var lista = $('#dlista');
  if (lista) {
    lista.innerHTML = CARRO.length ? CARRO.map(function (l) {
      var p = IX[l.i];
      return '<div class="li">' +
        (foto(p) ? '<a href="' + url(p) + '"><img src="' + foto(p) + '" alt="' + esc(p.n) + '"></a>' : '<span></span>') +
        '<div><p class="li__nom"><a href="' + url(p) + '">' + esc(p.n) + '</a></p>' +
          '<p class="li__meta">' + esc(meta(p)) + '</p>' +
          '<span class="li__ctr"><button type="button" data-menos="' + p.i + '" aria-label="Quitar uno">−</button>' +
          '<span>' + l.q + '</span><button type="button" data-mas="' + p.i + '" aria-label="Agregar uno">+</button></span></div>' +
        '<div class="li__der"><b>' + clp(p.p * l.q) + '</b>' +
          '<button class="li__quitar" type="button" data-quitar="' + p.i + '">Quitar</button></div></div>';
    }).join('')
      : '<div class="drawer__vacio"><p>Tu carro está vacío.</p>' +
        '<a class="btn btn--oro btn--bloque" href="/collections/catalogo">Ver el catálogo</a>' +
        '<a class="btn btn--linea btn--bloque" style="margin-top:8px" href="/pages/test">No sé cuál quiero</a></div>';
  }

  var cruz = $('#dcruz');
  if (cruz) {
    var enCarro = CARRO.map(function (l) { return l.i; });
    var sug;
    if (CARRO.length) {
      var falta2 = UMBRAL_ENVIO - tot;
      sug = falta2 > 0 ? sugerirEnvio(tot, enCarro, 2) : [];
      if (!sug.length) {
        var base = IX[CARRO[CARRO.length - 1].i];
        sug = (D.cross[base.i] || []).map(function (c) { return IX[c.id]; })
          .filter(function (p) { return p && p.img && enCarro.indexOf(p.i) < 0; }).slice(0, 2);
      }
    } else {
      sug = P.filter(function (p) { return p.img && p.k === 'arabe' && p.fo === 'perfume'; })
             .sort(function (a, b) { return b.p - a.p; }).slice(0, 2);
    }
    cruz.innerHTML = sug.length
      ? '<h4>' + (CARRO.length && (UMBRAL_ENVIO - tot) > 0 ? 'Suma uno de estos y el envío queda gratis' : 'Se lleva bien con') + '</h4>' +
        sug.map(function (p) {
          return '<div class="mini">' + (foto(p) ? '<img src="' + foto(p) + '" alt="' + esc(p.n) + '">' : '<span></span>') +
            '<div><strong>' + esc(p.n) + '</strong><span>' + esc(meta(p)) + '</span></div>' +
            '<div><b>' + clp(p.p) + '</b><button type="button" data-add="' + p.i + '">Sumar</button></div></div>';
        }).join('') : '';
  }

  var dpie = $('#dpie');
  if (dpie) {
    dpie.innerHTML = CARRO.length
      ? '<div class="drawer__tot"><span>Total</span><b>' + clp(tot) + '</b></div>' +
        (cuota(tot) ? '<p class="drawer__cuota">' + cuota(tot) + ' pagando con ' + MEDIOS_CUOTAS.map(function(m){return m.n;}).join(' y ') + '</p>'
                    : '<p class="drawer__cuota">Retiro gratis en ' + DIR + '</p>') +
        '<div class="drut">' +
          '<label class="drut__lb" for="dRut">RUT para la boleta</label>' +
          '<input class="drut__in" id="dRut" type="text" inputmode="text" autocomplete="off" ' +
            'spellcheck="false" placeholder="12.345.678-9" value="' + esc(GP.rutCarro || '') + '">' +
          '<p class="drut__err" id="dRutErr" hidden></p>' +
          '<p class="drut__ay">Con este RUT emitimos tu boleta. Si necesitas factura, completa el campo ' +
            '<b>Empresa</b> en el paso siguiente con tu razón social.</p>' +
        '</div>' +
        '<button class="btn btn--oro btn--bloque" type="button" id="dIrPagar">Ir a pagar</button>' : '';
    dpie.hidden = !CARRO.length;
  }
}

function pintarFav() {
  var e = $('#nfav');
  if (e) { e.textContent = FAV.length; e.setAttribute('data-n', FAV.length); }
  var d = $('#dnumf'); if (d) d.textContent = FAV.length ? '(' + FAV.length + ')' : '';
  var caja = $('#dfav');
  if (caja) {
    caja.innerHTML = FAV.length ? FAV.map(function (i) {
      var p = IX[i];
      return '<div class="li">' +
        (foto(p) ? '<a href="' + url(p) + '"><img src="' + foto(p) + '" alt="' + esc(p.n) + '"></a>' : '<span></span>') +
        '<div><p class="li__nom"><a href="' + url(p) + '">' + esc(p.n) + '</a></p>' +
          '<p class="li__meta">' + esc(meta(p)) + '</p>' +
          '<button class="btn btn--linea btn--sm" type="button" data-add="' + p.i + '">Agregar al carro</button></div>' +
        '<div class="li__der"><b>' + clp(p.p) + '</b>' +
          '<button class="li__quitar" type="button" data-fav="' + p.i + '">Quitar</button></div></div>';
    }).join('')
      : '<div class="drawer__vacio"><p>Todavía no guardas favoritos. El corazón de cada producto los guarda aquí.</p>' +
        '<a class="btn btn--oro btn--bloque" href="/collections/catalogo">Ver el catálogo</a></div>';
  }
  $$('[data-fav]').forEach(function (b) {
    if (b.classList.contains('ctool') || b.classList.contains('pdptool'))
      b.classList.toggle('on', FAV.indexOf(+b.getAttribute('data-fav')) >= 0);
  });
}

function pintarCmp() {
  var bar = $('#cmpbar'); if (!bar) return;
  bar.hidden = CMP.length === 0;
  $('#cmpl').innerHTML = CMP.map(function (i) {
    var p = IX[i];
    return '<span class="cmpchip">' + (foto(p) ? '<img src="' + foto(p) + '" alt="">' : '') +
      '<b>' + esc(p.n.split(' ').slice(0, 3).join(' ')) + '</b>' +
      '<button type="button" data-cmp="' + p.i + '" aria-label="Quitar del comparador">✕</button></span>';
  }).join('') + (CMP.length < 3 ? '<span class="cmpchip cmpchip--vacio">Puedes sumar ' + (3 - CMP.length) + ' más</span>' : '');
  var ir = $('#cmpir');
  ir.classList.toggle('btn--apagado', CMP.length < 2);
  $$('[data-cmp]').forEach(function (b) {
    if (b.classList.contains('ctool') || b.classList.contains('pdptool'))
      b.classList.toggle('on', CMP.indexOf(+b.getAttribute('data-cmp')) >= 0);
  });
}

/* ============================================================
   BUSCADOR AGRUPADO
   ============================================================ */
function buscar(q, lim) {
  q = sinAcento(q).trim();
  if (q.length < 2) return [];
  var ts = q.split(/\s+/), res = [];
  for (var i = 0; i < P.length; i++) {
    var p = P[i];
    var heno = sinAcento(p.n + ' ' + p.b + ' ' + p.sku + ' ' + (p.f || []).join(' ') + ' ' + p.ins + ' ' + notasDe(p).join(' '));
    var pts = 0, todos = true;
    for (var j = 0; j < ts.length; j++) {
      var k = heno.indexOf(ts[j]);
      if (k < 0) { todos = false; break; }
      pts += k < 40 ? 3 : 1;
    }
    if (todos) {
      if (sinAcento(p.n).indexOf(q) === 0) pts += 10;
      if (p.img) pts += 2;
      res.push([pts, p]);
    }
  }
  res.sort(function (a, b) { return b[0] - a[0]; });
  return res.slice(0, lim || 7).map(function (r) { return r[1]; });
}
GP.buscar = buscar;

var POPULARES = ['Lattafa', 'vainilla', 'Dior', 'oud', 'Khamrah', 'tester', 'ámbar'];

function montarBuscador(inputId, resId) {
  var inp = $('#' + inputId), caja = $('#' + resId);
  if (!inp || !caja) return;
  var t;
  function recientes() { return leer('gp_busq', []); }
  function guardaBusq(v) {
    v = v.trim(); if (v.length < 2) return;
    escribir('gp_busq', [v].concat(recientes().filter(function (x) { return x.toLowerCase() !== v.toLowerCase(); })).slice(0, 5));
  }
  function chips(lista) {
    return lista.map(function (x) { return '<button class="mchip" type="button" data-busq="' + esc(x) + '">' + esc(x) + '</button>'; }).join('');
  }
  function sugerencias() {
    var r = recientes();
    return '<div class="busca__bloque"><h5>Búsquedas frecuentes</h5><div class="busca__chips">' + chips(POPULARES) + '</div></div>' +
      (r.length ? '<div class="busca__bloque"><h5>Tus búsquedas</h5><div class="busca__chips">' + chips(r) + '</div></div>' : '') +
      '<a class="busca__pie" href="/pages/test">¿No sabes qué buscar? Haz el test →</a>';
  }
  function pinta() {
    var q = inp.value;
    caja.hidden = false;
    if (sinAcento(q).trim().length < 2) { caja.innerHTML = sugerencias(); return; }
    var prods = buscar(q, 6), nq = sinAcento(q);
    var marcas = marcaTop(90).filter(function (m) { return sinAcento(m.n).indexOf(nq) >= 0; }).slice(0, 3);
    var notas = notaTop(400).filter(function (n) { return sinAcento(n.n).indexOf(nq) >= 0; }).slice(0, 4);
    if (!prods.length && !marcas.length && !notas.length) {
      caja.innerHTML = '<p class="busca__vacio">No encontramos nada con “' + esc(q) + '”.<br>Prueba con la marca o con una nota, por ejemplo <b>vainilla</b>.</p>' + sugerencias();
      return;
    }
    caja.innerHTML =
      (marcas.length ? '<div class="busca__bloque"><h5>Marcas</h5><div class="busca__chips">' +
        marcas.map(function (m) { return '<a class="mchip" href="' + GP.T({m:m.n}) + '">' + esc(m.n) + ' <b>' + m.c + '</b></a>'; }).join('') + '</div></div>' : '') +
      (notas.length ? '<div class="busca__bloque"><h5>Notas olfativas</h5><div class="busca__chips">' +
        notas.map(function (n) { return '<a class="mchip" href="' + GP.T({nota:n.n}) + '">' + esc(n.n) + ' <b>' + n.c + '</b></a>'; }).join('') + '</div></div>' : '') +
      (prods.length ? '<div class="busca__bloque"><h5>Productos</h5>' + prods.map(function (p) {
        return '<a class="busca__it" href="' + url(p) + '">' + (foto(p) ? '<img src="' + foto(p) + '" alt="">' : '<span></span>') +
          '<div><strong>' + esc(p.n) + '</strong><span>' + esc(p.b || meta(p)) + '</span></div>' +
          '<b>' + clp(p.p) + '</b></a>';
      }).join('') + '</div>' : '') +
      '<a class="busca__pie" href="/search?q=' + encodeURIComponent(q) + '">Ver todos los resultados</a>';
  }
  inp.addEventListener('input', function () { clearTimeout(t); t = setTimeout(pinta, 110); });
  inp.addEventListener('focus', pinta);
  caja.addEventListener('click', function (e) {
    var b = e.target.closest('[data-busq]');
    if (b) { inp.value = b.getAttribute('data-busq'); pinta(); inp.focus(); }
  });
  document.addEventListener('click', function (e) {
    if (!caja.contains(e.target) && e.target !== inp && !e.target.closest('.busca__campo')) caja.hidden = true;
  });
  inp.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') caja.hidden = true;
    if (e.key === 'Enter') {
      var v = inp.value.trim();
      if (v) { guardaBusq(v); location.href = T({q:v}); }
    }
  });
}

/* ============================================================
   VISTA RÁPIDA
   ============================================================ */
function vistaRapida(id) {
  var p = IX[id]; if (!p) return;
  var n = notasDe(p), e = equiv(p);
  var wrap = document.createElement('div');
  wrap.className = 'drawer abierto';
  wrap.innerHTML = '<div class="drawer__velo" data-cerrar-vr></div>' +
    '<div class="drawer__panel" role="dialog" aria-label="Vista rápida">' +
      '<div class="drawer__tabs"><button class="dtab on" type="button">Vista rápida</button>' +
        '<button class="drawer__cerrar" type="button" data-cerrar-vr aria-label="Cerrar">' +
        '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>' +
      '<div class="drawer__lista">' +
        (foto(p) ? '<img src="' + foto(p) + '" alt="' + esc(p.n) + '" style="width:100%;max-height:250px;object-fit:contain;background:#fff;border:1px solid var(--linea);border-radius:4px;margin:16px 0">' : '') +
        (p.b ? '<span class="card__marca">' + esc(p.b) + '</span>' : '') +
        '<h3 style="font-family:var(--serif);font-weight:400;font-size:24px;margin:6px 0 8px;line-height:1.15">' + esc(p.n) + '</h3>' +
        '<p class="card__meta">' + esc(meta(p)) + ' · SKU ' + esc(p.sku) + '</p>' +
        '<p style="font-family:var(--serif);font-size:30px;font-weight:600;margin:10px 0 2px">' + clp(p.p) + '</p>' +
        (cuota(p.p) ? '<p style="font-size:12.5px;color:var(--tinta-3);margin:0 0 14px">' + cuota(p.p) + '</p>' : '<div style="height:12px"></div>') +
        (p.ins ? '<div class="card__eq" style="margin-bottom:14px">Dupe de <b>' + esc(p.ins) + '</b>' +
            (e ? ', que sale ' + clp(Math.round(e.mlB)) + ' el ml frente a ' + clp(Math.round(e.mlA)) + ' de este.' : '.') + '</div>' : '') +
        (n.length ? '<h4 style="font-size:10.5px;letter-spacing:.14em;text-transform:uppercase;color:var(--tinta-3);margin:14px 0 9px">Notas</h4><div class="notas">' +
          n.slice(0, 14).map(function (x) { return '<span class="nota">' + esc(x) + '</span>'; }).join('') + '</div>' : '') +
      '</div>' +
      '<div class="drawer__pie">' +
        (agotado(p)
          ? botonesAgotado(p, false)
          : '<button class="btn btn--oro btn--bloque" type="button" data-add="' + p.i + '">Agregar al carro</button>') +
        '<a class="btn btn--linea btn--bloque" style="margin-top:8px" href="' + url(p) + '">Ver la ficha completa</a>' +
      '</div></div>';
  document.body.appendChild(wrap);
  document.body.style.overflow = 'hidden';
  wrap.addEventListener('click', function (e) {
    if (e.target.closest('[data-cerrar-vr]')) { wrap.remove(); document.body.style.overflow = ''; }
    var a = e.target.closest('[data-add]');
    if (a) { agregar(+a.getAttribute('data-add'), 1, true); toast('Agregado al carro'); wrap.remove(); document.body.style.overflow = ''; abrirDrawer('carro'); }
  });
}

function sorprendeme() {
  var pool = P.filter(function (p) { return p.img && p.fo === 'perfume' && notasDe(p).length >= 4; });
  var p = pool[Math.floor(Math.random() * pool.length)];
  if (p) vistaRapida(p.i);
}
GP.sorprendeme = sorprendeme;

/* ---------- bloque de vistos recientes, reutilizable ---------- */
GP.bloqueVistos = function (excluir) {
  var l = GP.vistos().filter(function (p) { return p.img && p.i !== excluir; }).slice(0, 5);
  if (l.length < 2) return '';
  return '<section class="sec"><div class="cont">' +
    '<div class="cabsec"><div><p class="eyebrow">Seguiste mirando</p>' +
    '<h2 class="display" style="font-size:1.9rem">Lo que viste hace poco</h2></div></div>' +
    '<div class="grid grid--5">' + GP.grid(l) + '</div></div></section>';
};

/* ============================================================
   ARRANQUE
   ============================================================ */
GP.montar = function (activo) {
  if (document.getElementById('cab')) return;
  var top = document.createElement('div');
  // display:contents — si esta envoltura cuenta como caja, la cabecera queda "pegada"
  // dentro de sus 156 px y se va con el scroll: el sticky se mide contra el padre.
  top.className = 'cab-envoltorio';
  top.innerHTML = cabecera(activo);
  document.body.insertBefore(top, document.body.firstChild);

  var bot = document.createElement('div');
  bot.innerHTML = pie() + drawerHTML();
  document.body.appendChild(bot);

  montarBuscador('q', 'qres');
  montarBuscador('qm', 'qresm');
  pintarCarro(); pintarFav(); pintarCmp();
  sincronizar();

  var menu = $('#movil');
  $('#abrirMenu').addEventListener('click', function () { menu.classList.add('abierto'); document.body.style.overflow = 'hidden'; });
  $('#abrirCarro').addEventListener('click', function () { abrirDrawer('carro'); });
  $('#abrirFav').addEventListener('click', function () { abrirDrawer('fav'); });
  $('#dado').addEventListener('click', function (e) { e.preventDefault(); sorprendeme(); });
  $('#cmpclear').addEventListener('click', function () { CMP = []; escribir('gp_cmp', CMP); pintarCmp(); });
  $('#cmpir').addEventListener('click', function (e) { if (CMP.length < 2) { e.preventDefault(); toast('Suma al menos dos para comparar'); } });

  /* megamenú de marcas: el intervalo elegido muestra sus casas */
  $$('.mega--marcas').forEach(function (m) {
    $$('[data-letra]', m).forEach(function (bt) {
      function abrir() {
        var i = bt.getAttribute('data-letra');
        $$('[data-letra]', m).forEach(function (x) { x.classList.toggle('on', x === bt); });
        $$('[data-lista]', m).forEach(function (l) { l.classList.toggle('on', l.getAttribute('data-lista') === i); });
      }
      bt.addEventListener('mouseenter', abrir);
      bt.addEventListener('click', abrir);
    });
  });

  /* megamenú: la vista previa cambia al pasar por cada enlace */
  $$('.mega').forEach(function (m) {
    var box = $('[data-prev-box]', m);
    if (!box) return;
    $$('a[data-prev]', m).forEach(function (a) {
      a.addEventListener('mouseenter', function () {
        var d = PREVS[a.getAttribute('data-prev')];
        if (d) box.innerHTML = preview(d.l, d.t, d.h);
        $$('a[data-prev]', m).forEach(function (x) { x.classList.toggle('on', x === a); });
      });
    });
  });

  /* la cabecera se contrae al bajar */
  var cab = $('#cab');
  function vigilaCab() {
    cab.classList.toggle('cab--mini', (window.scrollY || 0) > 200);
    requestAnimationFrame(vigilaCab);
  }
  requestAnimationFrame(vigilaCab);

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cerrar-menu]')) { menu.classList.remove('abierto'); document.body.style.overflow = ''; }
    if (e.target.closest('[data-cerrar-carro]')) cerrarDrawer();

    var tab = e.target.closest('[data-tab]');
    if (tab) { verTab(tab.getAttribute('data-tab')); return; }

    var mac = e.target.closest('[data-macc]');
    if (mac) {
      var cu = $('#macc' + mac.getAttribute('data-macc'));
      var ab = mac.getAttribute('aria-expanded') === 'true';
      mac.setAttribute('aria-expanded', !ab); cu.hidden = ab;
      return;
    }
    var add = e.target.closest('[data-add]');
    if (add) {
      e.preventDefault();
      var id = +add.getAttribute('data-add');
      var enCard = add.classList.contains('card__add');
      // el carro se abre siempre: el cliente quiere ver que el producto entró
      agregar(id, 1, false);
      if (enCard) {
        add.textContent = 'Agregado ✓'; add.classList.add('listo');
        toast(IX[id].n + ' — agregado');
        setTimeout(function () { add.textContent = 'Agregar'; add.classList.remove('listo'); }, 1600);
      }
      return;
    }
    var fv = e.target.closest('[data-fav]');
    if (fv) { e.preventDefault(); favToggle(+fv.getAttribute('data-fav')); return; }
    var cp = e.target.closest('[data-cmp]');
    if (cp) { e.preventDefault(); cmpToggle(+cp.getAttribute('data-cmp')); return; }
    var av = e.target.closest('[data-avisar]');
    if (av) { e.preventDefault(); avisame(+av.getAttribute('data-avisar')); return; }
    var qk = e.target.closest('[data-quick]');
    if (qk) { e.preventDefault(); vistaRapida(+qk.getAttribute('data-quick')); return; }
    var mas = e.target.closest('[data-mas]'); if (mas) return cambiar(+mas.getAttribute('data-mas'), 1);
    var men = e.target.closest('[data-menos]'); if (men) return cambiar(+men.getAttribute('data-menos'), -1);
    var qt = e.target.closest('[data-quitar]'); if (qt) return quitar(+qt.getAttribute('data-quitar'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    cerrarDrawer(); menu.classList.remove('abierto'); document.body.style.overflow = '';
  });

  var hero = $('#hero');
  if (hero) carrusel(hero);
  confirmarAviso();
};

/* ---------- carrusel ---------- */
function carrusel(hero) {
  var slides = $$('.hero__slide', hero), dots = $$('.hero__dot', hero);
  if (slides.length < 2) return;
  var i = 0, timer;
  function ir(n) {
    slides[i].classList.remove('on'); dots[i] && dots[i].classList.remove('on');
    i = (n + slides.length) % slides.length;
    slides[i].classList.add('on');
    if (dots[i]) { dots[i].classList.remove('on'); void dots[i].offsetWidth; dots[i].classList.add('on'); }
    reloj();
  }
  function reloj() {
    clearTimeout(timer);
    if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    timer = setTimeout(function () { ir(i + 1); }, 1000 * (+hero.getAttribute('data-gp-segundos') || 7));
  }
  $('.hero__f--prev', hero).addEventListener('click', function () { ir(i - 1); });
  $('.hero__f--next', hero).addEventListener('click', function () { ir(i + 1); });
  dots.forEach(function (d, k) { d.addEventListener('click', function () { ir(k); }); });

  /* En el teléfono el banner se cambia deslizando, que es el gesto que la gente usa.
     Solo cuenta el arrastre claramente horizontal: si no, se traba el scroll vertical. */
  var x0 = null, y0 = null, moviendo = false;
  hero.addEventListener('touchstart', function (e) {
    var t = e.changedTouches[0]; x0 = t.clientX; y0 = t.clientY; moviendo = false;
    clearTimeout(timer);
  }, { passive: true });
  hero.addEventListener('touchmove', function (e) {
    if (x0 === null) return;
    var t = e.changedTouches[0];
    if (Math.abs(t.clientX - x0) > 12 && Math.abs(t.clientX - x0) > Math.abs(t.clientY - y0)) moviendo = true;
  }, { passive: true });
  hero.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0;
    if (moviendo && Math.abs(dx) > 45) ir(dx < 0 ? i + 1 : i - 1);
    else reloj();
    x0 = y0 = null;
  }, { passive: true });
  hero.addEventListener('mouseenter', function () { clearTimeout(timer); });
  hero.addEventListener('mouseleave', reloj);
  dots[0] && dots[0].classList.add('on');
  reloj();
}

/* ---------- helpers públicos ---------- */
if (window.GP && GP.ajustes) {
  if (GP.ajustes.umbral) UMBRAL_ENVIO = GP.ajustes.umbral;
  if (GP.ajustes.umbralRegiones) UMBRAL_REGIONES = GP.ajustes.umbralRegiones;
}
GP.UMBRAL = UMBRAL_ENVIO; GP.UMBRAL_REGIONES = UMBRAL_REGIONES;
/* Los logos de los medios que dan las 3 cuotas sin interés. Salen del mapa de archivos,
   así que si mañana se suma o se saca uno, basta con Archivos: aquí no se toca nada. */
function logosPago() {
  var l = MEDIOS_CUOTAS.map(function (m) {
    var u = amb('pago:' + m.s);
    return u ? '<img src="' + u + '" alt="' + esc(m.n) + '" loading="lazy">' : '';
  }).filter(Boolean).join('');
  return l ? '<span class="cuotas__logos">' + l + '</span>' : '';
}
GP.logosPago = logosPago; GP.MEDIOS_CUOTAS = MEDIOS_CUOTAS;
GP.CUOTAS = CUOTAS; GP.MIN_CUOTA = MIN_CUOTA;
GP.cuota = cuota; GP.meta = meta; GP.foto = foto; GP.url = url; GP.esc = esc;
GP.notasDe = notasDe; GP.porMl = porMl; GP.sugerirEnvio = sugerirEnvio;
GP.sinAcento = sinAcento; GP.$ = $; GP.$$ = $$;
/* ---------- flechas de las filas de producto ----------
   La fila ya se desliza con el dedo y con el trackpad; en escritorio, sin flechas,
   nadie se entera de que hay más productos a la derecha. Se cuelgan del título de la
   sección para no tapar las tarjetas. */
function flechasFila(caja) {
  if (!caja || caja.dataset.flechas || !caja.children.length) return;
  var sec = caja.closest('section') || caja.parentElement;
  var cab = sec && sec.querySelector('.cabsec');
  if (!cab) return;
  caja.dataset.flechas = '1';
  var nav = document.createElement('div');
  nav.className = 'filanav';
  nav.innerHTML =
    '<button class="filanav__b" type="button" data-d="-1" aria-label="Ver anteriores">\u2039</button>' +
    '<button class="filanav__b" type="button" data-d="1" aria-label="Ver siguientes">\u203a</button>';
  cab.appendChild(nav);
  var antes = nav.children[0], despues = nav.children[1];
  function paso() {
    var it = caja.firstElementChild;
    return it ? Math.round(it.getBoundingClientRect().width + 20) : 240;
  }
  function estado() {
    var max = caja.scrollWidth - caja.clientWidth - 2;
    nav.hidden = max <= 0;
    antes.disabled = caja.scrollLeft <= 2;
    despues.disabled = caja.scrollLeft >= max;
  }
  nav.addEventListener('click', function (e) {
    var b = e.target.closest('[data-d]');
    if (b) caja.scrollBy({ left: +b.getAttribute('data-d') * paso() * 2, behavior: 'smooth' });
  });
  caja.addEventListener('scroll', estado, { passive: true });
  window.addEventListener('resize', estado);
  estado();
}
GP.flechasFila = flechasFila;
GP.filasCarrusel = function () { $$('.grid--5').forEach(flechasFila); };

GP.abrirDrawer = abrirDrawer; GP.miniCard = miniCard;

/* ---------- el RUT bloquea el paso a pagar ----------
   Va por delegación porque el pie del carro se vuelve a pintar en cada cambio:
   si se enganchara al botón, el listener se perdería a la primera. */
function rutDelCarro() { return $('#dRut'); }
function errorRut(msg) {
  var e = $('#dRutErr'); if (!e) return;
  e.textContent = msg || ''; e.hidden = !msg;
  var i = rutDelCarro(); if (i) i.classList.toggle('drut__in--mal', !!msg);
}
document.addEventListener('click', function (ev) {
  var b = ev.target.closest && ev.target.closest('#dIrPagar');
  if (!b) return;
  ev.preventDefault();
  var i = rutDelCarro();
  var v = i ? i.value : '';
  if (!rutLimpio(v)) { errorRut('Necesitamos tu RUT para emitir la boleta.'); if (i) i.focus(); return; }
  if (!rutValido(v)) { errorRut('Ese RUT no es válido. Revísalo, incluido el dígito verificador.'); i.focus(); return; }
  errorRut('');
  i.value = rutFormato(v);
  GP.rutCarro = i.value;
  b.disabled = true; b.textContent = 'Un momento…';
  // El atributo viaja a la orden como note_attributes: es de ahí que Syncron saca el RUT.
  pedir(GP.rutas.carro + '/update.js', { attributes: { RUT: rutBsale(v) } })
    .then(function () { window.location.href = '/checkout'; })
    .catch(function () {
      b.disabled = false; b.textContent = 'Ir a pagar';
      errorRut('No pudimos guardar el RUT. Inténtalo de nuevo.');
    });
});
document.addEventListener('input', function (ev) {
  if (ev.target && ev.target.id === 'dRut') errorRut('');
});
document.addEventListener('blur', function (ev) {
  if (ev.target && ev.target.id === 'dRut' && rutValido(ev.target.value)) {
    ev.target.value = rutFormato(ev.target.value);
    GP.rutCarro = ev.target.value;
  }
}, true);

})();
